import React, { useState, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { detalleProyectoContext } from '../../../pages/Normas/DetalleProyecto'

function ModalAuditor(props) {

    const { user, idProyecto } = useContext(detalleProyectoContext)

    const [opcionAuditor, setOpcionAuditor] = useState("")
    const [file, setFile] = useState("")

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const handleClose = () => {
        setOpcionAuditor("")
        setFile("")
        setErrors({})
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        setOpcionAuditor(e.target.value)
    }

    const handleChangeFile = (e) => {
        setFile(e.target.files[0])
    }
 
    const handleSubmitAuditor = async (e) => {
        e.preventDefault()
        
        let errors = {}

        if(!opcionAuditor.trim()){
            errors.opcion = "Escoja una opción"
        }
        if (!file) {
            errors.archivo = "Agregue un archivo válido.";
        }

        if((Object.keys(errors).length === 0)){
            setErrors({})
            const formData = new FormData()
            formData.append('user', JSON.stringify(user))
            formData.append('idProyecto', idProyecto)
            formData.append('estado', opcionAuditor)
            formData.append('file', file)
            formData.append('titulo', file.name)

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/evaluarProyecto`, {
                    method: "POST",
                    body: formData
                })
                const data = await res.json()
                if(data.status !== 0){
                    setModalErr(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // actualizar tareas
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setErrors(errors)
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__auditor'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Auditar proyecto</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmitAuditor} className='d-flex flex-column align-items-center'>
                    <div className='w-100 d-flex flex-column mb-3'>
                        <div className='w-100 d-flex flex-row justify-content-between'>
                            <div className="w-50 form-check me-3">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="opcion" 
                                    value="1"
                                    checked={opcionAuditor === "1"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="opcion">Aprobar</label>
                            </div>
                            <div className="w-50 form-check me-3">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="opcion" 
                                    value="2" 
                                    checked={opcionAuditor === "2"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="opcion">Denegar</label>
                            </div>
                        </div>
                        {errors?.opcion && (
                            <span className='text-danger mt-2'><i className="bi bi-exclamation-circle me-1"></i>{errors?.opcion}</span>
                        )}
                    </div>
                    <div className='w-100 d-flex flex-column mb-3'>
                        <label className='block fw-medium mb-1 text-blue-500'>Subir documento</label>
                        <input 
                            type='file'
                            onChange={handleChangeFile}
                            className={`w-auto form-control rounded-pill border no-outline focus-ring ${
                                errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                            }`}
                        />
                        {errors?.archivo && (
                            <span className='text-danger mt-2'><i className="bi bi-exclamation-circle me-1"></i>{errors?.archivo}</span>
                        )}
                    </div>
                    {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>Enviar constancia</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalAuditor